/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetCompanyApiRateLimitRequest
 */
export interface SetCompanyApiRateLimitRequest {
  /**
   *
   * @type {string}
   * @memberof SetCompanyApiRateLimitRequest
   */
  endpoint: string;
  /**
   *
   * @type {number}
   * @memberof SetCompanyApiRateLimitRequest
   */
  requestsPerHour: number;
}

/**
 * Check if a given object implements the SetCompanyApiRateLimitRequest interface.
 */
export function instanceOfSetCompanyApiRateLimitRequest(
  value: object,
): value is SetCompanyApiRateLimitRequest {
  if (!("endpoint" in value) || value["endpoint"] === undefined) return false;
  if (!("requestsPerHour" in value) || value["requestsPerHour"] === undefined)
    return false;
  return true;
}

export function SetCompanyApiRateLimitRequestFromJSON(
  json: any,
): SetCompanyApiRateLimitRequest {
  return SetCompanyApiRateLimitRequestFromJSONTyped(json, false);
}

export function SetCompanyApiRateLimitRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetCompanyApiRateLimitRequest {
  if (json == null) {
    return json;
  }
  return {
    endpoint: json["endpoint"],
    requestsPerHour: json["requestsPerHour"],
  };
}

export function SetCompanyApiRateLimitRequestToJSON(
  json: any,
): SetCompanyApiRateLimitRequest {
  return SetCompanyApiRateLimitRequestToJSONTyped(json, false);
}

export function SetCompanyApiRateLimitRequestToJSONTyped(
  value?: SetCompanyApiRateLimitRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint: value["endpoint"],
    requestsPerHour: value["requestsPerHour"],
  };
}
